import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Download, Printer, X } from "lucide-react";

export default function PdfPreviewDialog({ open, url, filename, title = "Preview Dokumen", onClose }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose && onClose()}>
      <DialogContent className="max-w-6xl w-[95vw] h-[90vh] p-0 flex flex-col gap-0 overflow-hidden" data-testid="pdf-preview-dialog">
        <DialogHeader className="p-3 border-b border-slate-200 flex-row items-center justify-between space-y-0">
          <DialogTitle className="font-display flex items-center gap-2 text-base">
            <Printer size={16} className="text-navy-900" />{title}
          </DialogTitle>
          <div className="flex gap-2">
            {url && (
              <a href={url} download={filename}>
                <Button size="sm" className="bg-navy-900 hover:bg-navy-800 text-white" data-testid="pdf-preview-download">
                  <Download size={14} className="mr-1" />Download
                </Button>
              </a>
            )}
            <Button size="sm" variant="outline" onClick={onClose} data-testid="pdf-preview-close">
              <X size={14} className="mr-1" />Tutup
            </Button>
          </div>
        </DialogHeader>
        <div className="flex-1 bg-slate-100">
          {url ? (
            <iframe src={url} title={title} className="w-full h-full border-0" data-testid="pdf-preview-iframe" />
          ) : (
            <div className="flex items-center justify-center h-full text-slate-400">Memuat preview...</div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
